import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveDirective as _resolveDirective, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0249fc6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-lg-row flex-column result-buttons column-row-gap-10" }
const _hoisted_2 = { class: "result-buttons__button-group flex" }
const _hoisted_3 = ["data-cy-id", "aria-disabled"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#file-download" })
], -1))
const _hoisted_5 = { class: "result-buttons__button-group" }
const _hoisted_6 = ["aria-disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#file-download" })
], -1))
const _hoisted_8 = { class: "container px-0 py-9" }
const _hoisted_9 = { class: "py-1" }
const _hoisted_10 = {
  key: 0,
  "aria-atomic": "true",
  class: "alert alert-error",
  ref: "formErrorsAlert",
  role: "alert"
}
const _hoisted_11 = { class: "alert-body" }
const _hoisted_12 = { class: "alert-heading" }
const _hoisted_13 = { class: "alert-text" }
const _hoisted_14 = ["data-cy"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "py-3" }
const _hoisted_17 = { ref: "formGroup" }
const _hoisted_18 = { class: "py-4 row form-group" }
const _hoisted_19 = {
  class: "col-md-3 form-group",
  id: "choose-calculation-div",
  style: {"margin-top":"24px"}
}
const _hoisted_20 = {
  class: "form-label",
  for: "input-choose-calculation"
}
const _hoisted_21 = { class: "ml-2" }
const _hoisted_22 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_23 = ["value", "id"]
const _hoisted_24 = ["value"]
const _hoisted_25 = {
  class: "col-md-2 form-group",
  id: "choose-basisyear-div",
  style: {"margin-top":"24px"}
}
const _hoisted_26 = {
  class: "form-label",
  for: "input-choose-basisyear"
}
const _hoisted_27 = { class: "ml-2" }
const _hoisted_28 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_29 = ["value", "id"]
const _hoisted_30 = ["value", "id"]
const _hoisted_31 = {
  class: "col-md-2 form-group",
  id: "yearly-growth-rate-div"
}
const _hoisted_32 = {
  class: "form-label",
  for: "input-yearly-growth-rate"
}
const _hoisted_33 = { class: "form-input-wrapper form-input-wrapper--suffix" }
const _hoisted_34 = ["data-error", "pattern"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-input-suffix",
  "aria-hidden": "true"
}, "%", -1))
const _hoisted_36 = { class: "col-md-2 form-group" }
const _hoisted_37 = {
  class: "form-label",
  for: "input-type-growth-rate"
}
const _hoisted_38 = ["value"]
const _hoisted_39 = ["value"]
const _hoisted_40 = {
  class: "col-md-3 form-group",
  id: "forecast-name-div"
}
const _hoisted_41 = {
  class: "form-label",
  for: "input-forecast-name"
}
const _hoisted_42 = ["data-error"]
const _hoisted_43 = { class: "w-percent-100" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_45 = {
  key: 0,
  "aria-atomic": "true",
  class: "alert alert-info",
  role: "alert",
  style: {"width":"100%","display":"flex"},
  id: "info-box-wrapper-div-start-year-emf-year-different"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"0 0 3%"} }, [
  /*#__PURE__*/_createElementVNode("svg", {
    "aria-hidden": "true",
    class: "info-icon-size",
    focusable: "false"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#info" })
  ])
], -1))
const _hoisted_47 = { style: {"flex":"1"} }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_49 = { class: "col-md-2 form-group" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = ["disabled", "name"]
const _hoisted_52 = { key: 1 }
const _hoisted_53 = ["name"]
const _hoisted_54 = {
  key: 1,
  class: "w-percent-100"
}
const _hoisted_55 = {
  id: "forecast-result-header",
  style: {"margin-top":"50px"}
}
const _hoisted_56 = { id: "forecast-result-main-text" }
const _hoisted_57 = {
  "aria-atomic": "true",
  class: "alert alert-info",
  role: "alert",
  style: {"max-width":"100%","display":"flex"},
  id: "info-box-wrapper-div"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"0 0 3%"} }, [
  /*#__PURE__*/_createElementVNode("svg", {
    "aria-hidden": "true",
    class: "info-icon-size",
    focusable: "false"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#info" })
  ])
], -1))
const _hoisted_59 = { style: {"flex":"1"} }
const _hoisted_60 = {
  key: 0,
  "data-cy-id": "forecast-result-summary",
  style: {"padding-left":"65px"}
}
const _hoisted_61 = {
  key: 1,
  style: {"padding-left":"65px"}
}
const _hoisted_62 = {
  key: 2,
  style: {"padding-left":"65px"}
}
const _hoisted_63 = {
  class: "pt-6",
  id: "forecast-result-section"
}
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { class: "container px-0 d-print-pagebreak" }
const _hoisted_66 = {
  "data-cy-id": "forecast-result-summary-scope1",
  class: "bg-alternative-green"
}
const _hoisted_67 = { style: {"padding":"20px"} }
const _hoisted_68 = { class: "container px-0 d-print-pagebreak" }
const _hoisted_69 = {
  key: 0,
  "aria-atomic": "true",
  class: "alert alert-info",
  role: "alert",
  style: {"max-width":"100%","display":"flex"},
  id: "info-box-declaration-wrapper-div"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"0 0 3%"} }, [
  /*#__PURE__*/_createElementVNode("svg", {
    "aria-hidden": "true",
    class: "info-icon-size",
    focusable: "false"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#info" })
  ])
], -1))
const _hoisted_71 = { style: {"flex":"1"} }
const _hoisted_72 = {
  key: 1,
  "aria-atomic": "true",
  class: "alert alert-info",
  role: "alert",
  style: {"max-width":"100%","display":"flex"},
  id: "info-box-declaration2-wrapper-div"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"0 0 3%"} }, [
  /*#__PURE__*/_createElementVNode("svg", {
    "aria-hidden": "true",
    class: "info-icon-size",
    focusable: "false"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#info" })
  ])
], -1))
const _hoisted_74 = { style: {"flex":"1"} }
const _hoisted_75 = {
  "data-cy-id": "forecast-result-summary-scope2",
  class: "bg-alternative-green"
}
const _hoisted_76 = { style: {"padding":"20px"} }
const _hoisted_77 = { class: "container px-0 d-print-pagebreak" }
const _hoisted_78 = {
  "data-cy-id": "forecast-result-summary-scope3",
  class: "bg-alternative-green"
}
const _hoisted_79 = { style: {"padding":"20px"} }
const _hoisted_80 = { key: 1 }
const _hoisted_81 = { class: "row justify-content-center" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column invisible" }, null, -1))
const _hoisted_83 = {
  key: 0,
  class: "flex-md-column text-center",
  style: {"padding-right":"20px"}
}
const _hoisted_84 = { style: {"margin-right":"8px"} }
const _hoisted_85 = {
  class: "category-box upstream-color-base",
  style: {"font-size":"small","margin-bottom":"0"}
}
const _hoisted_86 = {
  class: "category-box upstream-color-end",
  style: {"font-size":"small","margin-top":"0"}
}
const _hoisted_87 = {
  key: 1,
  class: "flex-md-column text-center",
  style: {"padding-right":"20px"}
}
const _hoisted_88 = {
  class: "category-box downstream-color-base",
  style: {"font-size":"small","margin-bottom":"0"}
}
const _hoisted_89 = {
  class: "category-box downstream-color-end",
  style: {"font-size":"small","margin-top":"0"}
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column invisible" }, null, -1))
const _hoisted_91 = { class: "container px-0" }
const _hoisted_92 = ["aria-disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_RichText = _resolveComponent("RichText")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_SharedHeader = _resolveComponent("SharedHeader")!
  const _component_CypressTestElement = _resolveComponent("CypressTestElement")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ForecastColumnChart = _resolveComponent("ForecastColumnChart")!
  const _component_Scope3CategorySelect = _resolveComponent("Scope3CategorySelect")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SharedHeader, null, {
      firstColumn: _withCtx(() => [
        _createElementVNode("h1", null, [
          _createVNode(_component_SimpleText, { "text-key": "forecast.calculate-forecast.title" })
        ]),
        _createElementVNode("span", null, [
          _createVNode(_component_RichText, { "text-key": "forecast.calculate-forecast.header-text" })
        ])
      ]),
      secondColumn: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              id: "result-export-excel-link",
              class: _normalizeClass(["button button-secondary", { 'button-disabled' : !_ctx.isCompleted }]),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exportToExcel && _ctx.exportToExcel(...args))),
              "data-cy-id": 'klimakompasset-resultat-' + _ctx.forecast.forcastHeader?.forecastId,
              "aria-disabled": !_ctx.isCompleted
            }, [
              _hoisted_4,
              _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.button.download" })
            ], 10, _hoisted_3),
            _createVNode(_component_Tooltip, {
              style: `vertical-align: middle;`,
              textKey: 'forecast.download-excel-tooltip',
              size: "lg"
            }, null, 8, ["textKey"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              id: "download_pdf_button",
              class: _normalizeClass(["button button-secondary flex-grow-equally", { 'button-disabled' : !_ctx.isCompleted }]),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleDownloadPdf && _ctx.handleDownloadPdf(...args))),
              "aria-disabled": !_ctx.isCompleted
            }, [
              _hoisted_7,
              _createVNode(_component_SimpleText, { "text-key": "forecast.reduction-target.button.pdf" })
            ], 10, _hoisted_6)
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("h2", null, [
        _createVNode(_component_SimpleText, { "text-key": "forecast.calculate-forecast.sub-title" })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_RichText, { "text-key": "forecast.calculate-forecast.sub-header-text" })
      ]),
      (_ctx.formValidation.formErrors.size)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, [
                _createVNode(_component_SimpleText, { "text-key": "generic.input.error.title" })
              ]),
              _createElementVNode("ul", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formValidation.formErrors, ([key, value]) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: key,
                    "data-cy": 'error_' + key
                  }, [
                    _createElementVNode("a", {
                      href: "javascript:void(0)",
                      onClick: _withModifiers(($event: any) => (_ctx.focusInput(key)), ["prevent"]),
                      style: {"text-decoration":"none"}
                    }, _toDisplayString(value), 9, _hoisted_15)
                  ], 8, _hoisted_14))
                }), 128))
              ])
            ])
          ], 512))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("form", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, [
                _createVNode(_component_SimpleText, { "text-key": "forecast.calculate-forecast.field.choose-calculation.name" })
              ]),
              _createElementVNode("span", _hoisted_21, [
                _createVNode(_component_Tooltip, { "text-key": 'forecast.calculate-forecast.field.choose-calculation.tooltip' }, null, 8, ["text-key"])
              ]),
              (!_ctx.editExistingForecast)
                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 0,
                    "aria-labelledby": "choose-calculation-div",
                    class: "form-select",
                    name: "options",
                    id: "input-choose-calculation",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCalculationId) = $event)),
                    onFocusout: _cache[3] || (_cache[3] = ($event: any) => (_ctx.watchCalculationId())),
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.watchCalculationId()))
                  }, [
                    _createElementVNode("option", _hoisted_22, [
                      _createVNode(_component_SimpleText, { "text-key": "generic.input.dropdown.option-select.name" })
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([..._ctx.possibleCalculations.sort((a, b) => a.calculationPurpose.name.localeCompare(b.calculationPurpose.name))], (calculation) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: calculation.calculationPurpose.name,
                        value: calculation.id,
                        id: calculation.calculationPurpose.name
                      }, _toDisplayString(calculation.calculationPurpose.name), 9, _hoisted_23))
                    }), 128))
                  ], 544)), [
                    [_vModelSelect, _ctx.selectedCalculationId]
                  ])
                : (_openBlock(), _createElementBlock("input", {
                    key: 1,
                    class: "form-input",
                    type: "text",
                    value: _ctx.calculationName,
                    readonly: "",
                    "aria-readonly": "true",
                    "aria-labelledby": "choose-calculation-div"
                  }, null, 8, _hoisted_24))
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("label", _hoisted_26, [
                _createVNode(_component_SimpleText, { "text-key": "forecast.calculate-forecast.field.choose-basisyear.name" })
              ]),
              _createElementVNode("span", _hoisted_27, [
                _createVNode(_component_Tooltip, { "text-key": 'forecast.calculate-forecast.field.choose-basisyear.tooltip' }, null, 8, ["text-key"])
              ]),
              _withDirectives(_createElementVNode("select", {
                "aria-labelledby": "choose-basisyear-div",
                class: "form-select",
                name: "options",
                id: "input-choose-basisyear",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedBasisYear) = $event))
              }, [
                _createElementVNode("option", _hoisted_28, [
                  _createVNode(_component_SimpleText, { "text-key": "generic.input.dropdown.option-select.name" })
                ]),
                (_ctx.possibleBasisYears.length === 1)
                  ? (_openBlock(), _createElementBlock("option", {
                      key: 0,
                      value: _ctx.possibleBasisYears[0],
                      id: _ctx.possibleBasisYears[0].toString(),
                      selected: ""
                    }, _toDisplayString(_ctx.possibleBasisYears[0]), 9, _hoisted_29))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList([..._ctx.possibleBasisYears], (year) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: year,
                        value: year,
                        id: year.toString()
                      }, _toDisplayString(year), 9, _hoisted_30))
                    }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedBasisYear]
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("label", _hoisted_32, [
                _createVNode(_component_SimpleText, { "text-key": "forecast.calculate-forecast.field.yearly-growth-rate.name" })
              ]),
              _createElementVNode("div", _hoisted_33, [
                _withDirectives(_createElementVNode("input", {
                  onFocusout: _cache[6] || (_cache[6] = ($event: any) => (_ctx.watchYearlyGrowthRate())),
                  onKeydown: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validateLocalizedNumberInput($event, 'DECIMAL'))),
                  id: "input-yearly-growth-rate",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.yearlyGrowthRate) = $event)),
                  "data-error": _ctx.yearlyGrowthRateError,
                  class: "form-input",
                  name: "input-yearly-growth-rate",
                  pattern: _ctx.findRegexPattern('regex.validation.nummeric.signed.max-3-digits.max-2-decimals'),
                  size: "9",
                  required: ""
                }, null, 40, _hoisted_34), [
                  [_vModelText, _ctx.yearlyGrowthRate]
                ]),
                _hoisted_35
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("label", _hoisted_37, [
                _createVNode(_component_SimpleText, { "text-key": "forecast.calculate-forecast.field.type-growth-rate.name" })
              ]),
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                name: "options",
                id: "input-type-growth-rate",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.typeGrowthRate) = $event))
              }, [
                _createElementVNode("option", { value: _ctx.enumExponential }, [
                  _createVNode(_component_SimpleText, { "text-key": "forecast.calculate-forecast.field.type-growth-rate.option.exponential.name" })
                ], 8, _hoisted_38),
                _createElementVNode("option", { value: _ctx.enumLinear }, [
                  _createVNode(_component_SimpleText, { "text-key": "forecast.calculate-forecast.field.type-growth-rate.option.linear.name" })
                ], 8, _hoisted_39)
              ], 512), [
                [_vModelSelect, _ctx.typeGrowthRate]
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("label", _hoisted_41, [
                _createVNode(_component_SimpleText, { "text-key": "forecast.calculate-forecast.field.forecast-name.name" })
              ]),
              _withDirectives(_createElementVNode("input", {
                id: "input-forecast-name",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.forecastName) = $event)),
                "data-error": _ctx.forecastNameError,
                class: "form-input",
                name: "input-forecast-name",
                size: "50",
                maxlength: "50",
                minlength: "2",
                required: "",
                type: "text",
                onFocusout: _cache[11] || (_cache[11] = ($event: any) => (_ctx.watchInputForecastName()))
              }, null, 40, _hoisted_42), [
                [_vModelText, _ctx.forecastName]
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              (_ctx.startYearEmfYearDifferent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _hoisted_46,
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("p", null, [
                        _createElementVNode("strong", null, [
                          _createVNode(_component_SimpleText, { textKey: "calculate-forecast.important-header" })
                        ])
                      ]),
                      _hoisted_48,
                      _createElementVNode("span", null, [
                        _createVNode(_component_SimpleText, { textKey: "forecast.calculate-forecast.field.startYearEmfYearDifferent.error" })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_49, [
              (_ctx.isUpdateForecastAllowed())
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _createElementVNode("button", {
                      id: "submit-button-forecast",
                      style: {"margin-top":"31px"},
                      onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
                      disabled: _ctx.isLoadingPartially,
                      class: "button button-primary adjust-button-size",
                      name: _ctx.getContentfulString('forecast.calculate-forecast.button.submit.name')
                    }, [
                      _createVNode(_component_SimpleText, { "text-key": 'forecast.calculate-forecast.button.submit.name' }, null, 8, ["text-key"])
                    ], 8, _hoisted_51)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _createVNode(_component_Tooltip, { textKey: 'forecast.ec-version-not-up-to-date' }, null, 8, ["textKey"]),
                    _createElementVNode("button", {
                      style: {"margin-top":"8px"},
                      id: "submit-button-forecast",
                      disabled: "true",
                      class: "disabled no-pointer-events button button-primary adjust-button-size",
                      name: _ctx.getContentfulString('forecast.calculate-forecast.button.submit.name')
                    }, [
                      _createVNode(_component_SimpleText, { "text-key": 'forecast.calculate-forecast.button.submit.name' }, null, 8, ["text-key"])
                    ], 8, _hoisted_53)
                  ]))
            ])
          ])
        ], 512)
      ]),
      (_ctx.forecast.forcastHeader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
            _createVNode(_component_CypressTestElement, {
              id: "forecast-result-data-helper",
              state: _ctx.dataRenderState,
              inner: _ctx.dataContentSize
            }, null, 8, ["state", "inner"]),
            _createElementVNode("h2", _hoisted_55, [
              _createVNode(_component_SimpleText, { "text-key": "forecast.result.header" })
            ]),
            _createElementVNode("span", _hoisted_56, [
              _createVNode(_component_RichText, { "text-key": "forecast.result.main-text" })
            ]),
            _createElementVNode("div", _hoisted_57, [
              _hoisted_58,
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("p", null, [
                  _createElementVNode("strong", null, [
                    _createVNode(_component_SimpleText, { textKey: "calculate-forecast.important-header" })
                  ])
                ]),
                _createElementVNode("span", null, [
                  _createVNode(_component_RichText, { "text-key": "calculate-forecast.important-message2" })
                ])
              ])
            ]),
            (_ctx.forecast.forcastHeader)
              ? (_openBlock(), _createBlock(_component_SharedHeader, {
                  key: 0,
                  tabMenu: _ctx.menu,
                  "additional-css-class": 'forecast-tabs',
                  "additional-background-css-class": 'bg-alternative-green',
                  headerPadding: 'py-4',
                  "use-one-column": "true"
                }, {
                  firstColumn: _withCtx(() => [
                    (_ctx.partialLoadingHasData || _ctx.isCompleted)
                      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_60, null, 512)), [
                          [_directive_dompurify_html, _ctx.resultHeadlineSummary]
                        ])
                      : (_ctx.partialLoadingHasFailed)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            _createVNode(_component_SimpleText, { "text-key": "forecast.resultview.errorcalculatingforecast.messageshort" })
                          ]))
                        : (_ctx.isLoadingPartially)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                              _createVNode(_component_SimpleText, { "text-key": "forecast.calculate-forecast.headline.pendingload" })
                            ]))
                          : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["tabMenu"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_63, [
              _createVNode(_component_router_view, { forecast: _ctx.forecast }, null, 8, ["forecast"]),
              (_ctx.partialLoadingHasData || _ctx.isCompleted)
                ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("h3", null, [
                        _createVNode(_component_SimpleText, { "text-key": 'forecast.resultview.scope1chart.header' }, null, 8, ["text-key"])
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _withDirectives(_createElementVNode("div", _hoisted_67, null, 512), [
                          [_directive_dompurify_html, _ctx.resultHeadlineSummaryScope1]
                        ])
                      ]),
                      _createElementVNode("h4", null, [
                        _createVNode(_component_SimpleText, { "text-key": "forecast.resultview.chartheader" })
                      ]),
                      _createVNode(_component_ForecastColumnChart, {
                        ref: "scope1ColumnChart",
                        width: '66%',
                        id: "scope1-column-chart",
                        "raw-data": _ctx.forecast.calculations?.sort((a, b) => a.year - b.year),
                        settings: _ctx.constants.FORECAST_FILTER_STATICSCOPE + _ctx.constants.FORECAST_FILTER_SCOPE1
                      }, null, 8, ["raw-data", "settings"])
                    ]),
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("h3", null, [
                        _createVNode(_component_SimpleText, { "text-key": 'forecast.resultview.scope2chart.header' }, null, 8, ["text-key"])
                      ]),
                      (!this.calculationForecasted.electricityEnvironmentDeclaration)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                            _hoisted_70,
                            _createElementVNode("div", _hoisted_71, [
                              _createElementVNode("p", null, [
                                _createElementVNode("strong", null, [
                                  _createVNode(_component_SimpleText, { textKey: "calculate-forecast.declaration-info.header" })
                                ])
                              ]),
                              _createElementVNode("span", null, [
                                _createVNode(_component_SimpleText, { textKey: "calculate-forecast.declaration-electricity.message" })
                              ])
                            ])
                          ]))
                        : (this.calculationForecasted.electricityEnvironmentDeclaration)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                              _hoisted_73,
                              _createElementVNode("div", _hoisted_74, [
                                _createElementVNode("p", null, [
                                  _createElementVNode("strong", null, [
                                    _createVNode(_component_SimpleText, { textKey: "calculate-forecast.declaration-info.header" })
                                  ])
                                ]),
                                _createElementVNode("span", null, [
                                  _createVNode(_component_SimpleText, { textKey: "calculate-forecast.declaration-environment.message" })
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_75, [
                        _withDirectives(_createElementVNode("div", _hoisted_76, null, 512), [
                          [_directive_dompurify_html, _ctx.resultHeadlineSummaryScope2]
                        ])
                      ]),
                      _createElementVNode("h4", null, [
                        _createVNode(_component_SimpleText, { "text-key": "forecast.resultview.chartheader" })
                      ]),
                      _createVNode(_component_ForecastColumnChart, {
                        ref: "scope2ColumnChart",
                        width: '66%',
                        id: "scope2-column-chart",
                        "raw-data": _ctx.forecast.calculations?.sort((a, b) => a.year - b.year),
                        settings: _ctx.constants.FORECAST_FILTER_STATICSCOPE + _ctx.constants.FORECAST_FILTER_SCOPE2
                      }, null, 8, ["raw-data", "settings"])
                    ]),
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("h3", null, [
                        _createVNode(_component_SimpleText, { "text-key": 'forecast.resultview.scope3chart.header' }, null, 8, ["text-key"])
                      ]),
                      _createElementVNode("div", _hoisted_78, [
                        _withDirectives(_createElementVNode("div", _hoisted_79, null, 512), [
                          [_directive_dompurify_html, _ctx.resultHeadlineSummaryScope3]
                        ])
                      ]),
                      _createElementVNode("h4", null, [
                        _createVNode(_component_SimpleText, { "text-key": "forecast.resultview.chartheader" })
                      ]),
                      _createVNode(_component_ForecastColumnChart, {
                        ref: "scope3ColumnChart",
                        width: '66%',
                        id: "scope3-column-chart",
                        "raw-data": _ctx.forecast.calculations?.sort((a, b) => a.year - b.year),
                        settings: _ctx.constants.FORECAST_FILTER_STATICSCOPE + _ctx.constants.FORECAST_FILTER_SCOPE3
                      }, null, 8, ["raw-data", "settings"])
                    ]),
                    (_ctx.forecast)
                      ? (_openBlock(), _createBlock(_component_Scope3CategorySelect, {
                          key: 0,
                          id: "scope3-category-select",
                          ref: "categoriesMultiselect",
                          forecast: _ctx.forecast,
                          aria: { 'aria-labelledby': 'multiselect-scopes-label' }
                        }, null, 8, ["forecast"]))
                      : _createCommentVNode("", true),
                    (_ctx.forecast.forcastHeader.isCreationCompleted)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                          _createElementVNode("div", _hoisted_81, [
                            _hoisted_82,
                            (this.containsUpstreams && this.chartContainsUpstreams)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                  _createElementVNode("h6", _hoisted_84, [
                                    _createVNode(_component_SimpleText, { "text-key": "calculate-forecast.category-graph.upstream-label" })
                                  ]),
                                  _createElementVNode("p", _hoisted_85, _toDisplayString(this.forecastBasisYear), 1),
                                  _createElementVNode("p", _hoisted_86, _toDisplayString(this.forecastEndYear), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (this.containsDownstreams && _ctx.chartContainsDownstreams)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                  _createElementVNode("h6", null, [
                                    _createVNode(_component_SimpleText, { "text-key": "calculate-forecast.category-graph.downstream-label" })
                                  ]),
                                  _createElementVNode("p", _hoisted_88, _toDisplayString(this.forecastBasisYear), 1),
                                  _createElementVNode("p", _hoisted_89, _toDisplayString(this.forecastEndYear), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _hoisted_90
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_91, [
      _createElementVNode("a", {
        class: _normalizeClass(["button button-primary mr-4", { 'button-disabled' : !_ctx.isCompleted }]),
        href: "javascript:void(0)",
        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.reductionTarget())),
        "aria-disabled": !_ctx.isCompleted
      }, [
        _createVNode(_component_SimpleText, { "text-key": "forecast.next.reductiontarget.button" })
      ], 10, _hoisted_92)
    ])
  ], 64))
}